// @ts-check
import React, { Component } from 'react';
import { Link } from 'react-router';
import { hideModal } from 'shared/actions/ModalActions';
import styles from './NewReferralTypeModal.module.scss';
import specialistImgSrc from './images/specialist.svg';
import radiologyImgSrc from './images/radiology.svg';
import infusionTherapySrc from './images/infusions.svg';
import addictionTreatmentSrc from './images/addiction_treatment.svg';
import physicalTherapyImgSrc from './images/physical_therapy.svg';
import { connect } from 'react-redux';
import ChooseNetwork from './ChooseNetwork';
import { browserHistory } from 'react-router';
import uid from 'uid';

const TileLink = ({ to, onClick, imgSrc, label }) => (
  <Link to={`${to}&uid=${uid()}`} onClick={onClick} className={styles.TileLink}>
    <div className={styles.TileLink__content}>
      <img className={styles.TileLink__image} src={imgSrc} alt={to} />
      <div className={styles.TileLink__label}>{label}</div>
    </div>
  </Link>
);

function pathForReferralType(referralType, networkId) {
  const basePath = `/a/portal/referral_profiles/new?selected_network_id=${networkId}`;
  return referralType.specialtyId
    ? `${basePath}&specialty_id=${referralType.specialtyId}`
    : basePath;
}

const referralTypeNames = [
  'specialist',
  'radiology',
  'infusion_therapy',
  'addiction_treatment',
  'physical_therapy',
];

class NewReferralModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedNetworkId:
        props.availableNetworks.length === 1 ? props.availableNetworks[0].id : null,
    };
  }

  selectNetwork = networkId => {
    const network = this.findNetwork(networkId);
    const referralTypes = network.referralTypes;
    if (referralTypes.length === 1) {
      hideModal();
      browserHistory.push(pathForReferralType(referralTypes[0], networkId));
    } else {
      this.setState({ selectedNetworkId: networkId });
    }
  };

  findNetwork = networkId => {
    return this.props.availableNetworks.find(network => network.id === networkId);
  };

  render() {
    return (
      <NewReferralModalTemplate
        availableNetworks={this.props.availableNetworks}
        selectedNetwork={this.findNetwork(this.state.selectedNetworkId)}
        selectNetwork={this.selectNetwork}
      />
    );
  }
}

const NewReferralModalTemplate = ({ availableNetworks, selectedNetwork, selectNetwork }) =>
  selectedNetwork ? (
    <NewReferralTypeModal
      selectedNetworkId={selectedNetwork.id}
      referralTypes={selectedNetwork.referralTypes}
    />
  ) : (
    <ChooseNetwork availableNetworks={availableNetworks} selectNetwork={selectNetwork} />
  );

const NewReferralTypeModal = ({ selectedNetworkId, referralTypes }) => {
  const [
    specialistReferral,
    radiologyReferral,
    infusionTherapyReferral,
    addictionTreatmentReferral,
    physicalTherapyReferral,
  ] = referralTypeNames.map(name => referralTypes.find(rt => rt.name === name));

  return (
    <div className={styles.NewReferralTypeModal_container} data-spec-id="NewReferralTypeModal">
      <div className={styles.modal_header}>
        <h4>New Referral</h4>
        <h5>Please select referral type:</h5>
      </div>
      <div className={styles.modal_body}>
        {specialistReferral ? (
          <TileLink
            to={`/a/portal/referral_profiles/new?selected_network_id=${selectedNetworkId}`}
            onClick={hideModal}
            imgSrc={specialistImgSrc}
            label="Specialist"
          />
        ) : null}
        {radiologyReferral ? (
          <TileLink
            to={`/a/portal/referral_profiles/new?selected_network_id=${selectedNetworkId}&specialty_id=${radiologyReferral.specialtyId}`}
            onClick={hideModal}
            imgSrc={radiologyImgSrc}
            label="Radiology"
          />
        ) : null}
        {infusionTherapyReferral ? (
          <TileLink
            to={`/a/portal/referral_profiles/new?selected_network_id=${selectedNetworkId}&specialty_id=${infusionTherapyReferral.specialtyId}`}
            onClick={hideModal}
            imgSrc={infusionTherapySrc}
            label="Infusion Therapy"
          />
        ) : null}
        {addictionTreatmentReferral ? (
          <TileLink
            to={`/a/portal/referral_profiles/new?selected_network_id=${selectedNetworkId}&specialty_id=${addictionTreatmentReferral.specialtyId}`}
            onClick={hideModal}
            imgSrc={addictionTreatmentSrc}
            label="Addiction Treatment"
          />
        ) : null}
        {physicalTherapyReferral ? (
          <TileLink
            to={`/a/portal/referral_profiles/new?selected_network_id=${selectedNetworkId}&specialty_id=${physicalTherapyReferral.specialtyId}`}
            onClick={hideModal}
            imgSrc={physicalTherapyImgSrc}
            label="Physical Therapy"
          />
        ) : null}
      </div>
    </div>
  );
};

const mapStateToProps = state => ({
  availableNetworks: state.referralWizard.availableNetworks,
});

export default connect(mapStateToProps)(NewReferralModal);
